import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class LiifeCoreService {

  constructor(private http: HttpClient) { }

  loginByDescopeTokenWithoutDevice(tenantPublicKey: string, sessionToken: string, refreshToken: string): Observable<{ headers: any, body: any }> {
    const url = `${environment.coreApiBaseUrl}/auth/login-by-descope-token-without-device`;
    const headers = new HttpHeaders({
      'x-public-key': tenantPublicKey,
      'Content-Type': 'application/json'
    });
    const body = {
      descopeSessionToken: sessionToken,
      descopeRefreshToken: refreshToken,
    };

    return this.http.post(url, body, { headers, observe: 'response' }).pipe(
      map(response => ({
        headers: response.headers.keys().reduce((acc, key) => {
          acc[key] = response.headers.get(key);
          return acc;
        }, {} as any),
        body: response.body
      }))
    );
  }

  getGoogleToken(code: string) {
    const url = `${environment.coreApiBaseUrl}/auth/google/token`;
    return this.http.get(url, {
      headers: {
        Authorization: localStorage.getItem('Authorization'),
      },
      observe: 'response',
      params: {
        code,
      },
    }).pipe(map(response => response.body as any));
  }

}